import { ReactNode } from 'react'

interface FormFieldProps {
  label: string | ReactNode
  children: ReactNode
  error?: { message?: string }
  labelClassName?: string
  containerClassName?: string
}

export function FormField({
  label,
  children,
  error,
  labelClassName = 'block text-xs text-gray-600 mb-1',
  containerClassName = ''
}: FormFieldProps) {
  return (
    <div className={containerClassName}>
      <label className={labelClassName}>{label}</label>
      {children}
      {/* Espaço fixo reservado para mensagem de erro - não desloca elementos */}
      <div className="min-h-[20px] relative">
        {error && (
          <p className="text-red-500 text-sm mt-1 absolute top-0 left-0">{error.message}</p>
        )}
      </div>
    </div>
  )
}

